export default __webpack_public_path__ + "static/portfolio-f026d700997edd6c3c4e9169fca25652.png";